export default __webpack_public_path__ + "static/media/006-ideas.242a9179.png";